import { Component, OnInit, inject } from '@angular/core';
import { LiveEvent, LiveEventQuery } from 'src/app/api/models';
import { LiveEventsService } from 'src/app/api/services';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatCard } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import {
  EVENT_TOUR_STEPS,
  showLiveEventTour,
} from '../../onboarding/live-event-tour';
import { TourTrackType } from '../../onboarding/guided-tour';
import { SubscriptionLimit } from 'src/app/cms/common/dialogs/subscription-limit-warning/subscription-limit-warning.component';
import {
  DashboardCardBaseComponent,
  getSteps,
  ProgressBarData,
  ProgressStep,
} from '../dashboard-card-base.component';
import { ListConfig } from 'src/app/cms/list/list.types';
import { getLiveEventListConfig } from 'src/app/cms/live-event/cms-live-event-select-event.component';
import { QuickFeedbackOverlayService } from 'src/app/cms/common/quick-feedback-overlay/quick-feedback-overlay.service';
import { AuthService } from 'src/app/auth/auth.service';
import { NgTemplateOutlet } from '@angular/common';
import { ProgressStatusBarComponent } from '../progress-dialog/progress-status-bar/progress-status-bar.component';

@Component({
  selector: 'qa-live-event-card',
  templateUrl: './live-event-card.component.html',
  styleUrls: ['./live-event-card.component.scss'],
  imports: [
    MatCard,
    RouterLink,
    MatIcon,
    ButtonComponent,
    TranslateModule,
    NgTemplateOutlet,
    ProgressStatusBarComponent,
  ],
})
export class LiveEventCardComponent
  extends DashboardCardBaseComponent<LiveEvent>
  implements OnInit
{
  eventConfig: ListConfig<LiveEvent>;
  steps: ProgressStep[];
  progress: ProgressBarData;
  cardType = TourTrackType.LIVE_EVENT;

  private eventsService = inject(LiveEventsService);
  private feedbackService = inject(QuickFeedbackOverlayService);
  private auth = inject(AuthService);

  ngOnInit(): void {
    this.getEvents();
    this.eventConfig = getLiveEventListConfig(
      this.eventsService,
      this.matDialog,
      this.dialog,
      this.snackBar,
      this.translator,
      this.router,
      this.auth,
      this.panelService,
      this.userJourney,
      this.editService,
      this.subscriptionLimit,
      this.feedbackService
    );
    const data = getSteps(TourTrackType.LIVE_EVENT, this.userJourney);
    this.steps = data.steps;
    this.progress = data.progressData;
    this.loadPreferences();
  }

  getEvents() {
    this.eventsService
      .queryEvents({
        body: {
          filters: {},
          sorting: [
            {
              option: 'created_at',
              direction: 'DESC',
            },
          ],
          paging: {
            page_size: 4,
          },
        } as Partial<LiveEventQuery> as LiveEventQuery,
      })
      .subscribe((res) => {
        this.items = res.data;
        this.totalItems = res.pagination.total;
        this.subscriptionLimit.subscriptionLimit.LIVE_EVENT_COUNT =
          res.pagination.total;
        this.isLoaded = true;
      });
  }

  openAddContentDialog(event) {
    event.stopPropagation();
    this.openAddContentDialogBase(
      SubscriptionLimit.LIVE_EVENT_COUNT,
      this.eventConfig.wizardImports,
      'content.wizardActions.title.createLiveEvent'
    );
  }

  openVideo(event) {
    event.stopPropagation();
    this.openVideoBase(TourTrackType.LIVE_EVENT, 'liveEvent');
  }

  openStep(event) {
    event.stopPropagation();
    this.openStepBase(
      TourTrackType.LIVE_EVENT,
      'https://quizacademy.de/akademie/live-event/'
    );
  }

  onGuidedTour(event) {
    event.stopPropagation();
    showLiveEventTour(
      this.injector,
      EVENT_TOUR_STEPS.START_TOUR,
      this.items.length ? null : EVENT_TOUR_STEPS.CLICK_ON_ADD
    );
  }

  onProgressClick(event: MouseEvent) {
    event.stopPropagation();
    const data = {
      title: 'dashboardNew.progressSection.liveEventsProgress',
      tourType: TourTrackType.LIVE_EVENT,
      stepsData: {
        steps: this.steps,
        progressData: this.progress,
      },
    };
    this.openProgressDialog(data);
  }
}
